import { BaseDto } from '../../base/baseDto.model';
import { MenuDto } from '../menu/menuDto.model';

export class CasoUsoDto  extends BaseDto{
    public icon!:string
    public path!:string
    public menu : MenuDto = new MenuDto();
}
